export type ThemeMode = 'light' | 'dark';

export function currentThemeMode(root: HTMLElement = document.documentElement): ThemeMode {
  return root.dataset.theme === 'dark' ? 'dark' : 'light';
}

// Dev-only switch for checking the dark tokens: `?theme=dark` sets data-theme="dark" on the root.
// Any other query leaves the attribute as index.html wrote it.
export function applyThemeModeFromUrl(search: string, root: HTMLElement): ThemeMode {
  if (new URLSearchParams(search).get('theme') === 'dark') {
    root.setAttribute('data-theme', 'dark');
  }
  return currentThemeMode(root);
}
